import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
import HeroView from '../views/Hero'

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView
  },
  {
    path: '/hero',
    name: 'HeroView',
    component: HeroView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
